import { render, staticRenderFns } from "./AttributeTable.vue?vue&type=template&id=e2e10e24&"
import script from "./AttributeTable.vue?vue&type=script&lang=js&"
export * from "./AttributeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports